import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import InfoIcon from '@material-ui/icons/Info';
import Tooltip from '@mui/material/Tooltip';
import _ from "lodash";

const HBA1C = (props) => {
    const hBA1CChart = Array.isArray(props?.dashboardLineChart) ? props.dashboardLineChart : [];

    const categories = [
        "Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
    ];


    const lineChart = {
        chart: {
            type: 'column',
            backgroundColor: null,
            height: '320',
        },
        title: {
            text: '',
            align: 'left'
        },
        xAxis: {
            categories: categories,
            crosshair: true,
            accessibility: {
                description: 'Months'
            }
        },
        yAxis: {
            min: 0,
            title: {
                text: ''
            }
        },
        credits: {
            enabled: false,
        },
        plotOptions: {
            column: {
                pointWidth: 20,
                pointPadding: 0.2,
                groupPadding: 0.1,
                borderWidth: 2
            }
        },
        series: [
            {
                name: 'Target Range (Good control)',
            data: [
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"January"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"January"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"February"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"February"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"March"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"March"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"April"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"April"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"May"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"May"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"June"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"June"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"July"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"July"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"August"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"August"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"September"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"September"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"October"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"October"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"November"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"November"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"December"})?(_.find(hBA1CChart,{indicatornames:"Target Range (Good control)",months:"December"}).counts):0,
            ],
            color: "#203864", 
            },
            {
                name: 'High (Poor control)',
            data: [
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"January"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"January"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"February"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"February"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"March"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"March"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"April"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"April"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"May"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"May"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"June"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"June"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"July"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"July"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"August"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"August"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"September"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"September"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"October"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"October"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"November"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"November"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"December"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"December"}).counts):0,
            ],
            color: "#ff779e", 
            },
            {
                name: 'Needs Attention',
            data: [
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"January"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"January"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"February"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"February"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"March"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"March"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"April"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"April"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"May"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"May"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"June"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"June"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"July"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"July"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"August"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"August"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"September"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"September"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"October"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"October"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"November"})?(_.find(hBA1CChart,{indicatornames:"Needs Attention",months:"November"}).counts):0,
                _.find(hBA1CChart,{indicatornames:"Needs Attention",months:"December"})?(_.find(hBA1CChart,{indicatornames:"High (Poor control)",months:"December"}).counts):0,
            ],
            color: "#00acb1", 
            }
        ]
    };

    return (
        <div>
            <div className="main-second-section mb-2">
                <div className="heading">
                    <h4 className="mt-0 mb-0"> PATIENTS WITH CONTROLLED AND UNCONTROLLED HBA1C BY MONTH (For Year 2024)</h4>
                </div>
                <div className="main-icon">
                    <Tooltip title="HbA1C levels of patients over time.(Trend)">
                        <InfoIcon className="info-icon" />
                    </Tooltip>
                </div>
            </div>
            <HighchartsReact
                highcharts={Highcharts}
                options={lineChart}
            />
        </div>
    );
};

export default HBA1C;